import type { ServiceSeed } from '@/types';

/**
 * The blank-slate vertical ships with no services on purpose — the owner
 * builds their own catalog. The type still guarantees the shape they get.
 */
export const otherServices: readonly ServiceSeed[] = [];
